// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const baseRoute = '/mobile-appstore-assets'

export const BaseMobileAppstoreAssetsAreaRoutes = {
  route: baseRoute,

  Current: {
    route: '/current',
  },
  Next: {
    route: '/next',
  },
}

export const MobileAppstoreAssetsAreaRoutes = transformRoutes(
  BaseMobileAppstoreAssetsAreaRoutes,
)
